import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AssignOfficerService } from '../services/assign-officer.service';
import { IUser } from '../interfaces/iuser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-assign-officer',
  templateUrl: './assign-officer.component.html',
  styleUrls: ['./assign-officer.component.scss']
})
export class AssignOfficerComponent implements OnInit {

  private _team: number;
  private _divisionNo: number;
  private _officers: IUser[];
  
  assignmentForm : FormGroup;
 
  constructor(private fb: FormBuilder, private assignService: AssignOfficerService, private router:Router) { 
   
  }

  public get officers(): IUser[] {
    return this._officers;
  }

  public get team(): number {
    return this._team;
  }
  public get divisionNo(): number {
    return this._divisionNo;
  }
  
  ngOnInit() {
    this._officers = [];
    this.assignService.getOfficers().subscribe();
    this.createAddCommentForm();
    this._divisionNo = parseInt(localStorage.getItem("divno"));
   // this._team = this.assignToTeam(this.divisionNo)

  }

  private assignToTeam(divno: number): number{
     let teamno : number;
    // console.log(this._divisionNo);
    switch(divno){
      case 2:
        if(this.assignmentForm.controls.teamNo.value==="Team1"){
          teamno = 28; 
        }
        else if(this.assignmentForm.controls.teamNo.value==="Team2"){
          teamno = 27;
        }
        else if(this.assignmentForm.controls.teamNo.value==="Team3"){
          teamno = 29;
        }
        else if(this.assignmentForm.controls.teamNo.value==="Team4"){
          teamno = 36;
        }
        break;
      case 3:
          if(this.assignmentForm.controls.teamNo.value==="Team1"){
            teamno = 30; 
          }
          else if(this.assignmentForm.controls.teamNo.value==="Team2"){
            teamno = 31;
          }
          else if(this.assignmentForm.controls.teamNo.value==="Team3"){
            teamno = 32;
          }
          else if(this.assignmentForm.controls.teamNo.value==="Team4"){
            teamno = 37;
          }
          break;
        case 4:
        case 25:
            if(this.assignmentForm.controls.teamNo.value==="Team1"){
              teamno= 33; 
            }
            else if(this.assignmentForm.controls.teamNo.value==="Team2"){
              teamno = 34;
            }
            else if(this.assignmentForm.controls.teamNo.value==="Team3"){
              teamno = 35;
            }
            else if(this.assignmentForm.controls.teamNo.value==="Team4"){
              teamno = 38;
            }
            break;
          case 39:
            if(this.assignmentForm.controls.teamNo.value==="Team1"){
              teamno= 40; 
            }
            else if(this.assignmentForm.controls.teamNo.value==="Team2"){
              teamno = 41;
            }
            else if(this.assignmentForm.controls.teamNo.value==="Team3"){
              teamno = 42;
            }
            else if(this.assignmentForm.controls.teamNo.value==="Team4"){
              teamno = 43;
            }
            break;
          default:
              teamno = 0;
    }
    return teamno;
  }
  private createAddCommentForm(){
    this.assignmentForm = this.fb.group({
     teamNo: [''],
     username: [''],
    })
  }

  public getUserByTeam() {
    this._team = this.assignToTeam(this.divisionNo)
  
    this._officers =this.assignService.getUserByTeam(+this.team);
  }

  

  public assignOfficer(){
    const AssignModel : IAssignModel = {
      tccNo: localStorage.getItem("tccno"),
      teamNo: this._team,
      username: this.assignmentForm.controls.username.value
    }
    this.assignService.assignRequestToOfficer(AssignModel).subscribe(data=>{
         let d = data;
         this.router.navigate(['/admin']);
    });  
  }
}
